// Port of api/fuel/app/classes/controller/api/monty/session.php
import DB from 'offline/db'
import User from 'offline/model/user'

function earlyAccessSlugs(userId) {
	if (!userId) return []

	var rows = DB.query('SELECT early_slug, early_adopted FROM platform_early')
	var access = []

	for (var i = 0; i < rows.length; i++) {
		var adopted = rows[i].early_adopted || []
		if (typeof adopted === 'string') {
			try { adopted = JSON.parse(adopted) } catch (e) { adopted = [] }
		}
		if (!Array.isArray(adopted)) adopted = []
		if (adopted.indexOf(String(userId)) !== -1 || adopted.indexOf(parseInt(userId, 10)) !== -1) {
			access.push(rows[i].early_slug)
		}
	}

	return access
}

export default function(params) {
	var userId = params.sessionUserId || DB.meta('sync_user_id')
	if (!userId) return Promise.resolve({ session: { offline: true }, data: null })
	var user = User.with_id(userId)
	if (!user) return Promise.resolve({ session: { offline: true }, data: null })

	var data = user.to_array()
	data.nextSync = parseInt(user.get_date_next_sync() || 0, 10)
	data.date.upgraded = parseInt(user.get_date_upgrade() || 0, 10)
	data.upgraded = parseInt(user.get_upgrade() || 0, 10)
	data.countdown = !!user.get_upgrade()
	data.perks = user.get_perks() || {}
	data.early = earlyAccessSlugs(user.get_id())

	return Promise.resolve({ session: { offline: true }, data: data })
}
